/** @griffel:css-start [d] null **/
.ftuwxu6{display:inline-flex;}
.f122n59{align-items:center;}
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
.fuzgk9b{min-inline-size:0;}
.f1fedwem{font-family:var(--fontFamilyMonospace);}
.fy9rknc{font-size:var(--fontSizeBase200);}
.fjksvth{overflow-wrap:anywhere;}
.f1pbl6dw{font-variant-numeric:tabular-nums;}
/** @griffel:css-end **/